// extracted by mini-css-extract-plugin
module.exports = {"follow_button":"ccvcLzvj","grayFollow":"HhE3KHyr"};